var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6.76367,
    r: 3,
    stroke: "#14142B",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.26367,
    r: 2.5,
    stroke: "#14142B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.7637C1 15.45 3.68629 12.7637 7 12.7637V12.7637C10.3137 12.7637 13 15.45 13 18.7637V20.7637H1V18.7637Z",
    stroke: "#14142B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5374 16.4495L11.6149 16.8355L11.3613 16.2293L11.8171 15.7559L12.5374 16.4495ZM13 20.7637L13 21.7637L12 21.7637V20.7637H13ZM13.3571 20.7637L13.3571 19.7637H13.3571V20.7637ZM22 20.7637H23V21.7637H22V20.7637ZM12 18.7637C12 18.0783 11.8627 17.4275 11.6149 16.8355L13.4599 16.0635C13.8081 16.8957 14 17.8086 14 18.7637H12ZM12 20.7637V18.7637H14V20.7637H12ZM13 19.7637L13.3571 19.7637L13.3571 21.7637L13 21.7637L13 19.7637ZM13.3571 19.7637H22V21.7637H13.3571V19.7637ZM21 20.7637V20.2637H23V20.7637H21ZM21 20.2637C21 17.7784 18.9853 15.7637 16.5 15.7637V13.7637C20.0899 13.7637 23 16.6738 23 20.2637H21ZM16.5 15.7637C15.2263 15.7637 14.0777 16.2915 13.2578 17.143L11.8171 15.7559C12.9983 14.529 14.6606 13.7637 16.5 13.7637V15.7637Z",
    fill: "#14142B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPeople);
export default __webpack_public_path__ + "static/media/two-people.8513bfeb752ae686a97d22140a4bba95.svg";
export { ForwardRef as ReactComponent };